import React, { useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { css } from '@emotion/react';
import { Tooltip } from '@material-ui/core';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import { colors } from '@/styles';

function Button({ callbacks }) {
    return (
        <Tooltip title="select zipcodes by address radius">
            <button
                onClick={callbacks.onOpen}
                css={css`
                    background-color: ${colors.greens.primary} !important;
                    color: ${colors.white.primary};
                `}
            >
                <RadioButtonUncheckedIcon
                    css={css`
                        font-size: 16px;
                    `}
                />
            </button>
        </Tooltip>
    );
}

class Radius {
    constructor({ callbacks }) {
        this.map = null;
        this.callbacks = callbacks;
        this.container = document.createElement('div');
        this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
        this.root = createRoot(this.container);
    }

    onAdd(map) {
        this.map = map;
        this.root.render(<Button callbacks={this.callbacks} />);
        return this.container;
    }

    onRemove() {
        this.root.unmount();
        this.container.parentNode.removeChild(this.container);
        this.map = undefined;
    }
}

function RadiusControl({ map, location = 'top-right', callbacks }) {
    const control = useRef(null);

    useEffect(() => {
        if (map) {
            control.current = new Radius({
                callbacks: {
                    onOpen: () => callbacks.onOpen?.(),
                },
            });
            map.addControl(control.current, location);
        }

        return () => {
            if (control.current) {
                map?.removeControl(control.current);
            }
        };
    }, [map]);

    return null;
}

export default RadiusControl;
